import { render } from "./PaymentComponent.vue?vue&type=template&id=5d666bd3&scoped=true"
import script from "./PaymentComponent.vue?vue&type=script&lang=js"
export * from "./PaymentComponent.vue?vue&type=script&lang=js"

import "./PaymentComponent.vue?vue&type=style&index=0&id=5d666bd3&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d666bd3"]])

export default __exports__